/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from "react";
import { LocalizationContext } from "../../context/LocalizationContext";
import { AIContext } from "../../context/AIContext";
import { LocalizationInfo } from "@emt/emt-localization/lib/localization-info";
import button  from "@harmony/enablers/components/button/button";
import { createScope }  from "@harmony/enablers/react/scope-for-react";
import partnerCenterTheme  from "@harmony/enablers/themes/partner-center";
import { Modal } from "@emt/emt-react";
require("./enrollment-agreement-modal.css");

export interface HybridDeprecationModalProps {
  visible: boolean;
  isModern: boolean;
}

export interface HybridDeprecationModalCallbackProps {
  onClose: () => void;
}

const scope = createScope({
  reactInstance: React,
  styles: [partnerCenterTheme],
});

const Button = scope.forReact(button);

type HybridDeprecationModalPropsType = HybridDeprecationModalProps &
  HybridDeprecationModalCallbackProps;

export class HybridDeprecationModal extends React.Component<HybridDeprecationModalPropsType> {
  private firstFocusElement = React.createRef<HTMLAnchorElement>();

  constructor(props: HybridDeprecationModalPropsType) {
    super(props);
  }

  componentDidMount() {
    if (this.firstFocusElement.current) {
      this.firstFocusElement.current.focus();
    }
  }

  render(): JSX.Element {
    return (
      <LocalizationContext.Consumer>
        {(localization) => (
          <AIContext.Consumer>
            {(appInsights) => this.renderContent(localization, appInsights)}
          </AIContext.Consumer>
        )}
      </LocalizationContext.Consumer>
    );
  }

  private renderContent(localization: LocalizationInfo, appInsights: any) {
    return (
      <Modal
        visible={this.props.visible}
        body={
          <>
            <div className="spacer-ml-top">
              {
                <label className="form-label">
                  {this.addHyperlinks(
                    this.props.isModern
                      ? localization.strings[
                          "AadHybridDeprecationBannerContent"
                        ]
                      : localization.strings[
                          "MsaHybridDeprecationBannerContent"
                        ],
                    this.props.isModern,
                    appInsights
                  )}
                </label>
              }
            </div>

            <div className="spacer-ml-top">
              <hr />
            </div>

            <div>
              <div
                className="row spacer-ml-top"
                data-bi-area={"HybridDeprecationModal"}
              >
                <div className="col-xs-16">
                  <button
                    type="reset"
                    className="modal-btn-left-spacing btn"
                    onClick={() => this.props.onClose()}
                    data-bi-slot="1"
                    data-bi-id={"HybridDeprecationModalClose"}
                  >
                    {localization.strings["CloseModalText"]}
                  </button>
                </div>
              </div>
            </div>
          </>
        }
      >
        {" "}
      </Modal>
    );
  }

  private addWarningSign(text: string) {
    if (!text) {
      return <></>;
    }

    const splitText = text.split("{1}");
    if (splitText.length < 2) {
      return <>{text}</>;
    }

    return (
      <>
        {text.split("{1}")[0]}
        <span className="win-icon win-icon-marble-sm status-warning"></span>
        {text.split("{1}")[1]}
      </>
    );
  }

  private addHyperlinks(
    text: string,
    isEnvironmentModern: boolean,
    appInsights: any
  ): JSX.Element {
    if (!text) {
      return <></>;
    }

    return (
      <>
        {this.addWarningSign(text.split("{0}")[0])}
        <Button
          external
          target={"_blank"}
          appearance={"link"}
          href={
            isEnvironmentModern
              ? "/en-us/dashboard/incentives/enrollment/summary"
              : "/en-us/dashboard/incentives/enrollment/web"
          }
          onClick={() => {
            appInsights.trackEvent("ClickedHybridModalIncentivesSummary");
          }}
        >
          {text.split("{0}")[1]}
        </Button>
        {text.split("{0}")[2]}
        <Button
          external
          target={"_blank"}
          appearance={"link"}
          href="/en-us/pcv/users"
          onClick={() => {
            appInsights.trackEvent("ClickedHybridModalUserManagement");
          }}
        >
          {text.split("{0}")[3]}
        </Button>
        {text.split("{0}")[4]}
      </>
    );
  }
}
